import styled from 'styled-components'
import { Row, Col } from 'react-styled-flexboxgrid'
import variables from '../../styles/variables'
import { TextWrapper } from '../../styles/base'
import { Input, Heading } from '..'
import { headerStyles } from '../../styles/global'

export const Container = styled(TextWrapper)`
  width: 100%;
  background: ${variables.colors.silverTree.darker};
  padding: 70px 15px !important;
  color: white;
  position: relative;
  @media ${variables.media.sm} {
    padding: 70px 40px !important;
  }
  @media ${variables.media.md} {
    padding: 70px 180px !important;
  }
`

export const Header = styled(Heading)`
  ${headerStyles.headerSmall}
  font-family: ${variables.fonts.body};
  font-weight: 400;
  text-align: center;
  margin-bottom: 20px;
  @media ${variables.media.sm} {
    margin-bottom: 60px;
  }
`

export const CostLabel = styled.p`
  font-weight: bold;
  font-size: 1.2rem;
  margin: 0;
  margin-top: 20px;
`

export const InputLabel = styled.p`
  font-weight: bold;
  font-size: 1.2rem;
`

export const LabelCol = styled(Col)`

`

export const InputRowContainer = styled(Row)`
  padding: 5px 40px;
`

export const PricePerPeriod = styled.span`
  width: 100%;
  font-size: 2rem;
  font-weight: 700;
`

export const PriceInput = styled(Input)`
  text-align: right;
  background: #eee;
`
